export const colors = {
  gold: "#C5A06F",
  goldHover: "#b8915f",
  divider: "rgba(212, 184, 140, 0.4)",
  muted: "rgba(255, 255, 255, 0.75)",
  black: "#000000",
  charcoal: "#0d0d0d",
  white: "#ffffff",
  text: "#1a1a1a",
  placeholder: "#6b6b6b",
  error: "#d32f2f",
  salonNav: "#A14A3A",
  stylistNav: "#1E4F40",
};
